import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { tap, switchMap } from 'rxjs/operators';
import { BehaviorSubject, from, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

const ACCESS_TOKEN_KEY = 'my-access-token';
const REFRESH_TOKEN_KEY = 'my-refresh-token';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  currentAccessToken = null;
  url = environment.api_url;

  constructor(private http: HttpClient, private router: Router) {
    this.loadToken();
  }

  loadToken() {
    const token = localStorage.getItem(ACCESS_TOKEN_KEY);
    if (token) {
      this.currentAccessToken = token;
      this.isAuthenticated.next(true);
    } else {
      this.isAuthenticated.next(false);
    }
  }

  requestCode(userid: string): Observable<any> {
    var formData: any = new FormData();
    formData.append("userid", userid)
    return this.http.post(this.url + "/Authenticate/login", formData);
  }

  sendCode(userid: string, otp: string): Observable<any> {
    var formData: any = new FormData();
    formData.append("userid", userid)
    formData.append("otp", otp)
    return this.http.post(this.url + "/Authenticate/login", formData).pipe(
      switchMap((token: { token, refreshToken, isAuthenticated, message }) => {
        this.currentAccessToken = token.token
        localStorage.setItem(ACCESS_TOKEN_KEY, token.token);
        localStorage.setItem(REFRESH_TOKEN_KEY, token.refreshToken);
        return from(Promise.all([token.isAuthenticated, token.message]));
      }),
      tap(_ => {
        this.isAuthenticated.next(true);
      })
    );
  }

  getNewAccessToken() {
    const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);

    if (refreshToken && refreshToken != null) {
      var formData: any = new FormData();
      formData.append("token", refreshToken)
      return this.http.post(`${this.url}/Authenticate/RefreshToken`, formData);
    } else {
      // No stored refresh token
      // to login page
      return of(null);
    }
  }


  storeAccessToken(accessToken) {
    this.currentAccessToken = accessToken.token;
    const storeAccess = localStorage.setItem(ACCESS_TOKEN_KEY, accessToken.token);
    const storeRefresh = localStorage.setItem(REFRESH_TOKEN_KEY, accessToken.refreshToken);
    return from(Promise.all([storeAccess, storeRefresh]));
  }

  deleteAccessToken() {
    try {
      console.log('posting token to logout');
      const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);
      var formData: any = new FormData();
      formData.append("token", refreshToken)
      this.http.post(this.url + "/Authenticate/logout", formData).subscribe(()=>{
        this.currentAccessToken = null;
        this.isAuthenticated.next(false);
        localStorage.removeItem(ACCESS_TOKEN_KEY);
        localStorage.removeItem(REFRESH_TOKEN_KEY);
    
        document.location.reload();
      })
    }
    catch { }
  
  }

}
